<template>
  <div class="bottomButton" @click="clickHandle">
    <div class="zoomIn fx fx-center">

    <div class="text">{{text}}</div>
    <div class="arrow"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['text'],
    methods: {
      clickHandle() {
        this.$emit('getVIP');
        this.$emit('gotoDownload')
      } 
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import '../style/common.scss';
  .bottomButton {
    width: 100%;
    height: 64*$px;
    line-height: 64*$px;
    position: fixed;
    bottom: 0;
    text-align: center;
    color: #fff;
    @include bg('button_bg@3x.png');
    background-size: cover;
    .zoomIn {
      animation: zoomIn 1s infinite;
      @keyframes zoomIn {
        0%{
          transform: scale(1);
        }
        50% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
    }
    .arrow {
      @include bg('arrow@3x.png');
      width: 7*$px;
      height: 12*$px;
      margin-left: 6*$px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldFree/components/bottomButton.vue